export default __webpack_public_path__ + "static/media/003-Russia flag.cc78a704.svg";